import dayjs from 'dayjs';
import Configuracao from './Configuracao';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

/**
 * @classdesc Classe utilitária para agrupar métodos de manipulação de datas.
 */
export default class DataUtil {
    /**
     * Converte data no formato DD-MM-YYYY-HH-mm-ss para formato solicitado (por padrão, o formato retornado é DD/MM/YYYY HH:mm:ss).
     *
     * @public
     * @static
     * @param {string} dataFormatoRespostaBackend A data que deve ser convertida.
     * @param {string} [formato='DD/MM/YYYY HH:mm:ss'] Formato de data que deve ser retornado.
     * @returns {string} A data convertida.
     */
    static formatarData(dataFormatoRespostaBackend, formato = 'DD/MM/YYYY HH:mm:ss') {
        return dataFormatoRespostaBackend
            ? dayjs(dataFormatoRespostaBackend, Configuracao.FORMATO_DATAHORA_SERVICOS_PADRAO).format(formato)
            : '';
    }

    static getObjData(dataFormatoRespostaBackend) {
        return dataFormatoRespostaBackend
            ? dayjs(dataFormatoRespostaBackend, Configuracao.FORMATO_DATAHORA_SERVICOS_PADRAO)
            : null;
    }

    static isDiaJaPassou(dataFormatoRespostaBackend) {
        const hoje = dayjs();
        const dataObj = DataUtil.getObjData(dataFormatoRespostaBackend);
        return !!(hoje && dataObj && hoje.isAfter(dataObj, 'day'));
    }

    static isDataExataJaPassou(dataFormatoRespostaBackend) {
        const hoje = dayjs();
        const dataObj = DataUtil.getObjData(dataFormatoRespostaBackend);
        return !!(hoje && dataObj && hoje.isAfter(dataObj));
    }

    /**
     * Formata a data/hora conforme o formato lido pelo Excel.
     *
     * @param {string} dataHora A data/hora no formato padrão dos serviços.
     * @returns {string | null} A data/hora formatada.
     */
    static formatarDataHoraParaCsv(dataHora) {
        const formatoDataHora = 'YYYY-MM-DD HH:mm:ss';
        return dataHora ? dayjs(dataHora, Configuracao.FORMATO_DATAHORA_SERVICOS_PADRAO).format(formatoDataHora) : null;
    }
}
